import axios from "axios";
import authService from "./auth-service";

const API_URL = process.env.REACT_APP_API_V1_URL;
//const API_URL = "https://backend.kulmasohva.com:8080/api/v1/";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

let isTokenExpired = false;

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or user not authorized
      if (!isTokenExpired) {
        // prevents the user from clicking multiple "token expired" messages
        isTokenExpired = true;
        const tokenExpiredMessage = {
          en: "Your token has expired, please login again.",
          fi: "Istuntosi on vanhentunut. Kirjaudu uudelleen sisään.",
        };
        const language = (localStorage.getItem("language") ?? "en") as
          | "en"
          | "fi";
        authService.logout();
        window.location.href = "/login";
        window.alert(tokenExpiredMessage[language]);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
